import { useMemo, useState } from "react";
import { GraphCanvas, graphView } from "../components/Graph";
import type { Issue } from "../lib/tasks";
import { tx } from "../i18n";

/* ══ 패턴 페이지 › 일감 › 그래프의 부품(t-in-port-work-graph) ══
   상태별 노드 띠 · 선행(실선) · 하위(점선) · 접힌 하위 · 빈 상태. 서버를 안 부른다. */

const I = (id: string, title: string, status: Issue["status"], extra: Partial<Issue> = {}): Issue =>
  ({ id, title, status, parentId: null, childCount: 0, doneChildCount: 0, dependsOn: [], openSession: null, ...extra }) as Issue;

const ROWS: Issue[] = [
  I("t-e", "에픽", "in-progress", { childCount: 2, doneChildCount: 1 }), // copy-ignore: 견본 자료
  I("t-e1", "하위 끝남", "done", { parentId: "t-e" }), // copy-ignore: 견본 자료
  I("t-e2", "하위 검토", "review", { parentId: "t-e", dependsOn: ["t-e1"] }), // copy-ignore: 견본 자료
  I("t-b", "막힌 일", "blocked", { dependsOn: ["t-e"] }), // copy-ignore: 견본 자료
  I("t-r", "대기", "ready", { dependsOn: ["t-b"] }), // copy-ignore: 견본 자료
  I("t-t", "할 일", "todo"), // copy-ignore: 견본 자료
];

export function GraphStates() {
  const [expanded, setExpanded] = useState<Set<string>>(() => new Set(["t-e"]));
  const open = useMemo(() => graphView(ROWS, { foldKids: true, expanded, hideDone: false }), [expanded]);
  const shut = useMemo(() => graphView(ROWS, { foldKids: true, expanded: new Set(), hideDone: true }), []);
  const toggle = (id: string) =>
    setExpanded((x) => {
      const n = new Set(x);
      if (n.has(id)) n.delete(id);
      else n.add(id);
      return n;
    });
  return (
    <>
      <h3>{tx("pat.graph.open")}</h3>
      <GraphCanvas view={open} zoom={0.8} focus="t-b" foldKids expanded={expanded} onOpen={() => undefined} onToggle={toggle} />
      <h3>{tx("pat.graph.shut")}</h3>
      <GraphCanvas view={shut} zoom={0.8} focus={null} foldKids expanded={new Set()} onOpen={() => undefined} onToggle={() => undefined} />
    </>
  );
}
